module.exports = __webpack_public_path__ + "fonts/dxiconsios.a33af6e7.ttf";